import React, { useState, useEffect, useContext, Fragment } from 'react';
import Context from '../../../context';
import { language } from 'Root/constants';
import Data from 'Content/content.json';
import MakeupCategory from './item/MakeupCategory';
import NoMakeupWarning from './item/NoMakeupWarning';
import Shade from './item/Shades';
import { ClickLayer } from '../../../../ga4';

import './MakeupList.scss';

const Makeups = ({ handleShadeChange, selectedMakeup }) => {
  const {
    makeup,
    makeupCleared,
    updateMakeup,
    updateMakeupCleared,
  } = useContext(Context);
  const [state, setState] = useState({
    activeShade: '',
    makeupList: [],
  });

  useEffect(() => {
    const makeupMapping = {
      blush: 0,
      eyeshadow: 1,
      eyeliner: 2,
      eyelashes: 3,
      lipcolors: 4,
    };

    setTimeout(() => {
      const initMakeupList = [];
      Object.keys(selectedMakeup).forEach((id) => {
        if (selectedMakeup[id]) {
          handleShadeChange(selectedMakeup[id], id);
          initMakeupList[makeupMapping[id]] = selectedMakeup[id];
        }
      });
      setState({
        ...state,
        makeupList: initMakeupList,
      });
    }, 200);
  }, []);

  useEffect(() => {
    if (makeupCleared) {
      setState({
        activeShade: '',
        makeupList: [],
      });
      updateMakeup(0);
    }
  }, [makeupCleared]);

  const onMakeupClick = (index) => {
    ClickLayer('makeupclick');
    updateMakeup(index);
    updateMakeupCleared(false);
  };

  const onShadeClick = (shade) => {
    const { makeupList: updatedMakeupList } = state;
    updatedMakeupList[makeup] = shade.id;

    setState({
      ...state,
      activeShade: shade.id,
      makeupList: updatedMakeupList,
    });
    handleShadeChange(shade.id, updatedMakeupList[makeup]);
    updateMakeupCleared(false);
    ClickLayer('shadeclick');
  };

  const { activeShade, makeupList } = state;
  const makeupItems = Data.data.makeup[language];
  const { type, shades } = makeupItems[makeup];

  return (
    <Fragment>
      {makeupCleared && <NoMakeupWarning />}
      {!makeupCleared && (
        <Shade
          shades={shades}
          shadeSelected={activeShade}
          type={type}
          makeupList={makeupList}
          onShadeClick={onShadeClick}
        />
      )}

      <ul className="palette--wrapper palette--wrapper__makeup">
        {makeupItems.map((item, key) => {
          return (
            <MakeupCategory
              key={item.name}
              category={item}
              makeupIndex={makeup}
              categoryIndex={key}
              onClick={onMakeupClick}
              makeupCleared={makeupCleared}
            />
          );
        })}
      </ul>
    </Fragment>
  );
};

export default Makeups;
